<template>
  <div class="my-presentation-box">
    <div class="h-100 pp-list">
      <div class="row m-0 px-2">
        <div class="col-12 col-xl form-group m-0 p-0">
          <b-form @submit.prevent="handleSearch" class="row m-0">
            <div class="form-group pl-md-0 col-12 col-md-4 col-lg-3 col-xl-2">
              <input
                type="text"
                class="form-control form-control-sm form-control-muted"
                v-model="searchText"
                :placeholder="$t('common.search')"
                aria-label="Search"
              />
            </div>
            <div class="col-auto form-group pl-md-0">
              <button type="submit" title="search" class="btn p-0 text-body">
                <span class="material-symbols-outlined fs-22 p-1">search</span>
              </button>
              <button
                title="All Clear"
                class="btn p-0 text-body"
                @click="clearFilters"
              >
                <span class="material-symbols-outlined fs-22 p-1"
                  >filter_alt_off</span
                >
              </button>
            </div>
            <div class="col-auto ml-auto">
              <!-- <presentation-ppt-notification
                class="d-inline-block mr-2"
                @refresh="getPresentations"
                @open-presentation="openPresentationNotification"
              ></presentation-ppt-notification> -->
              <b-button
                variant="primary btn btn-primary px-4 rounded-pill"
                @click="openCreateModal"
              >
                Upload PPT Slides
              </b-button>
            </div>
          </b-form>
        </div>
      </div>

      <div class="container-fluid p-0 position-relative">
        <div class="position-absolute w-100">
          <wtr-loader
            v-if="loading"
            containerClass="align-items-center d-flex fs-18 justify-content-center"
            containerStyle="column-gap: 5px;"
            addText
            variant="primary"
          ></wtr-loader>
        </div>

        <div
          v-if="presentations && presentations.length > 0"
          class="h-100"
          :class="{ 'fetch-class': loading }"
        >
          <b-table
            thead-class="bg-primary text-light"
            primary-key="id"
            outlined
            responsive
            hover
            :fields="tableFields"
            :items="presentations"
            show-empty
            empty-text="No presentations found"
            :busy="loading"
          >
            <template v-slot:head(title)="data">
              <div class="d-inline-flex align-items-center text-nowrap">
                <div class="text-nowrap">{{ data.label }}</div>
                <span class="cursor-pointer" v-on:click="handleSort('name')">
                  &nbsp;<i class="fa fa-sort ml-1" aria-hidden="true"></i>
                </span>
              </div>
            </template>
            <template v-slot:head(description)="data">
              <div class="d-inline-flex align-items-center text-nowrap">
                <div class="text-nowrap">{{ data.label }}</div>
                <span class="cursor-pointer" v-on:click="handleSort('description')">
                  &nbsp;<i class="fa fa-sort ml-1" aria-hidden="true"></i>
                </span>
              </div>
            </template>
            <template v-slot:head(createdDateTime)="data">
              <div class="d-inline-flex align-items-center text-nowrap">
                <div class="text-nowrap">{{ data.label }}</div>
                <span class="cursor-pointer" v-on:click="handleSort('createdDate')">
                  &nbsp;<i class="fa fa-sort ml-1" aria-hidden="true"></i>
                </span>
              </div>
            </template>
            <template v-slot:cell(title)="row">
              <div class="fs-13">
                {{ row.item.title || row.item.name || "N/A" }}
              </div>
            </template>
            <template v-slot:cell(description)="row">
              <div class="fs-13">
                {{ row.item.description || "N/A" }}
              </div>
            </template>
            <template v-slot:cell(createdDateTime)="row">
              <div class="fs-13">
                {{
                  formatDate(row.item.createdDate || row.item.createdDateTime)
                }}
              </div>
            </template>
            <template v-slot:cell(slidesStatus)="row">
              <b-badge
                v-if="row.item.slidesStatus"
                :variant="getSlidesStatusVariant(row.item.slidesStatus)"
                class="fs-12 white-space-normal"
              >
                {{ getSlidesStatusLabel(row.item) }}
              </b-badge>
              <span v-else class="fs-13">N/A</span>
            </template>
            <template v-slot:cell(actions)="row">
              <table-actions
                :key="row.item.id"
              
                :editIcon="{ show: 'Edit' }"
                :deleteIcon=" { show: 'Delete' }"
                
                @edit="openEditModal(row.item)"
                @delete="deletePresentationFact(row.item)"
              ></table-actions>
            </template>
          </b-table>
        </div>
      </div>
      <no-data-found
        message="No presentations found"
        v-if="!loading && (!presentations || presentations.length === 0)"
      ></no-data-found>

      <div
        v-if="presentations && presentations.length > 0"
        class="row m-0 mt-5 align-items-center px-2"
        style="row-gap: 10px"
      >
        <div class="col-auto px-md-0">
          <select
            aria-label="Change Size"
            @change="handleSizeChange(Number($event.target.value))"
            class="form-control form-control-sm form-control-muted"
            style="width: 200px"
          >
            <option :value="null" selected class="fs-14">
              {{ $t("common.perPage") }}
            </option>
            <option
              class="fs-14"
              :value="item"
              v-for="(item, index) in pageSizeOptions"
              :key="index"
              :selected="paginationParams.size === item"
            >
              {{ item }}
            </option>
          </select>
        </div>

        <div class="col-auto">
          <b-pagination
            size="sm"
            pills
            @change="handlePageChange"
            class="m-0"
            :value="paginationParams.page + 1"
            :limit="3"
            :per-page="paginationParams.size"
            :total-rows="totalPresentations"
          ></b-pagination>
        </div>

        <div class="col-auto" v-if="totalPresentations > 1000">
          <div class="info-text">
            <i class="fa fa-info-circle"></i>
            {{ $t("notes.maximumOf1000Records") }}
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="presentation-form-modal"
      v-model="showFormModal"
      :title="form.id ? 'Update Presentation' : 'Create Presentation'"
      centered
      size="xl"
      hide-footer
      @hidden="resetForm"
    >
      <b-form @submit.prevent="savePresentation">
        <div class="row">
          <div class="col-12 col-lg-5">
            <presentation-details-section
              ref="presentationDetailsSection"
              :form="form"
              @update="form = $event"
            ></presentation-details-section>
            <hr />
            <presentation-ppt-upload-section
              ref="presentationPptUploadSection"
              :file="pptFile"
              :required="isPptRequired"
              :uploadStatus="pptUploadStatus"
              :uploadProgress="pptUploadProgress"
              @file-selected="handlePptFileSelected"
              @file-invalid="handlePptFileInvalid"
            ></presentation-ppt-upload-section>
          </div>
          <div class="col-12 col-lg-7 mt-3 mt-lg-0">
            <presentation-slide-grid
              :slides="presentationSlides"
              :loading="slidesLoading"
              :disabled="slidesSaving || slidesLoading || pptUploading"
              @reorder="reorderPresentationSlides"
              @delete-slide="deletePresentationSlideFact"
            ></presentation-slide-grid>
          </div>
        </div>
        <div class="d-flex justify-content-end">
          <b-button
            variant="secondary"
            class="mr-2"
            @click="showFormModal = false"
          >
            Cancel
          </b-button>
          <b-button
            variant="primary"
            type="submit"
            :disabled="saving || pptUploading || slidesSaving || !!pptFileError"
          >
            {{ saving || pptUploading || slidesSaving ? "Saving..." : "Save" }}
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal
      id="presentation-documents-modal"
      v-model="showDocumentsModal"
      :title="selectedPresentation ? selectedPresentation.name : 'Documents'"
      centered
      size="lg"
      hide-footer
      @hidden="resetDocuments"
    >
      <b-form @submit.prevent="uploadDocument" class="mb-3">
        <div class="row">
          <div class="col-12 col-md">
            <b-form-file
              v-model="documentFile"
              placeholder="Choose a file"
              browse-text="Browse"
              required
            ></b-form-file>
          </div>
          <div class="col-12 col-md-auto mt-2 mt-md-0">
            <b-button variant="primary" type="submit" :disabled="uploading">
              {{ uploading ? "Uploading..." : "Upload" }}
            </b-button>
          </div>
        </div>
      </b-form>

      <b-table
        small
        outlined
        responsive
        :items="documents"
        :fields="documentFields"
        :busy="documentsLoading"
        show-empty
        empty-text="No documents found"
      >
        <template v-slot:cell(name)="row">
          <a
            v-if="row.item.docPath"
            :href="row.item.docPath"
            target="_blank"
            rel="noopener"
          >
            {{ row.item.name }}
          </a>
          <span v-else>{{ row.item.name }}</span>
        </template>
        <template v-slot:cell(size)="row">
          {{ formatSize(row.item.size) }}
        </template>
        <template v-slot:cell(actions)="row">
          <button
            class="btn btn-link p-0 text-danger"
            title="Delete"
            @click="deleteDocument(row.item)"
          >
            <i class="fa fa-trash"></i>
          </button>
        </template>
      </b-table>
    </b-modal>
  </div>
</template>

<script>
import noDataFound from "../../../components/common/no-data-found.vue";
import PresentationDetailsSection from "./presentation-details-section.vue";
import PresentationPptUploadSection from "./presentation-ppt-upload-section.vue";
// import PresentationPptNotification from "./presentation-ppt-notification.vue";
import PresentationSlideGrid from "./presentation-slide-grid.vue";
import TableActionsComponent from "../../../components/common/table-actions.vue";
import {
  PPT_AZUREFAIL,
  PPT_ERROR,
  PPT_INPROCESS,
  PPT_PENDING,
  PPT_PROCESSED,
  PPT_PROCESSING,
  PPT_READYTOPROCESS,
  PPT_UNPROCESSED,
} from "../../../constants/constants-ppt";

export default {
  name: "my-presentation-box",
  components: {
    "no-data-found": noDataFound,
    "presentation-details-section": PresentationDetailsSection,
    // "presentation-ppt-notification": PresentationPptNotification,
    "presentation-ppt-upload-section": PresentationPptUploadSection,
    "presentation-slide-grid": PresentationSlideGrid,
    "table-actions": TableActionsComponent,
  },
  props: {
    currentFolder: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      saving: false,
      uploading: false,
      pptUploading: false,
      documentsLoading: false,
      slidesLoading: false,
      slidesSaving: false,
      showFormModal: false,
      showDocumentsModal: false,
      selectedPresentation: null,
      documentFile: null,
      pptFile: null,
      pptFileError: "",
      pptUploadStatus: "",
      pptUploadProgress: 0,
      statusRefreshInterval: null,
      statusRefreshMs: 10000,
      documents: [],
      presentationSlides: [],
      form: {
        id: null,
        name: "",
        description: "",
      },
      presentations: [],
      totalPresentations: 0,
      paginationParams: {
        page: 0,
        size: 10,
        sort: "createdDate,desc",
        sortDesc: true,
      },
      searchText: "",
      tableFields: [
        { key: "title", label: "Title" },
        { key: "description", label: "Description" },
        { key: "createdDateTime", label: "Created Date" },
        { key: "slidesStatus", label: "Slides Status" },
        { key: "actions", label: "Actions" },
      ],
      documentFields: [
        { key: "name", label: "Name" },
        { key: "size", label: "Size" },
        { key: "actions", label: "Actions" },
      ],
    };
  },
  computed: {
    isPptRequired() {
      return !this.form.id;
    },
    pageSizeOptions() {
      if (!this.totalPresentations) return [];
      const percentile = this.totalPresentations > 100 ? 10 : 5;
      const diff = this.totalPresentations % percentile;
      let total = this.totalPresentations + (percentile - diff);
      total = total > 1000 ? 1000 : total;
      let x = percentile;
      const options = [];
      while (x <= total) {
        options.push(x);
        x += percentile;
      }
      return options;
    },
  },
  watch: {
    currentFolder: {
      immediate: true,
      handler() {
        this.paginationParams.page = 0;
        this.getPresentations();
      },
    },
  },
  beforeDestroy() {
    this.stopStatusRefresh();
  },
  methods: {
    async getPresentations(options = {}) {
      if (!this.currentFolder) {
        this.presentations = [];
        this.totalPresentations = 0;
        this.stopStatusRefresh();
        return;
      }
      const silent = options && options.silent;

      const params = {
        folderId: this.currentFolder.id,
        userId: localStorage.getItem("userId"),
        page: this.paginationParams.page,
        size: this.paginationParams.size,
        sort: this.paginationParams.sort,
        sortDirection: this.paginationParams.sortDesc ? "desc" : "asc",
      };
      const body = {
        folderId: this.currentFolder.id,
        userId: this.currentFolder.userId || localStorage.getItem("userId"),
        searchText: this.searchText,
      };
      Object.keys(body).forEach((key) => {
        if (body[key] === null || body[key] === "" || body[key] === undefined) {
          delete body[key];
        }
      });

      if (!silent) {
        this.loading = true;
      }
      try {
        const response = await this.$api.getPresentationByFolder(params, body);
        const payload = response && response.data && response.data.payload;
        this.presentations =
          payload && payload.content ? payload.content : payload || [];
        this.totalPresentations =
          payload && payload.totalElements !== undefined
            ? payload.totalElements
            : this.presentations.length;
        this.updateStatusRefresh();
      } catch (error) {
        if (!silent) {
          this.$handleError(error);
          this.presentations = [];
          this.totalPresentations = 0;
        }
        this.stopStatusRefresh();
      } finally {
        if (!silent) {
          this.loading = false;
        }
      }
    },
    updateStatusRefresh() {
      if (this.hasActiveSlidesStatus()) {
        this.startStatusRefresh();
      } else {
        this.stopStatusRefresh();
      }
    },
    startStatusRefresh() {
      if (this.statusRefreshInterval) return;
      this.statusRefreshInterval = window.setInterval(() => {
        if (!this.loading) {
          this.getPresentations({ silent: true });
        }
      }, this.statusRefreshMs);
    },
    stopStatusRefresh() {
      if (!this.statusRefreshInterval) return;
      window.clearInterval(this.statusRefreshInterval);
      this.statusRefreshInterval = null;
    },
    hasActiveSlidesStatus() {
      return (this.presentations || []).some((presentation) =>
        this.isActiveSlidesStatus(presentation.slidesStatus),
      );
    },
    isActiveSlidesStatus(status) {
      return [
        PPT_UNPROCESSED,
        PPT_PENDING,
        PPT_INPROCESS,
        PPT_READYTOPROCESS,
        PPT_PROCESSING,
      ].includes(status);
    },
    getSlidesStatusVariant(status) {
      switch (status) {
        case PPT_PROCESSED:
          return "success";
        case PPT_AZUREFAIL:
        case PPT_ERROR:
          return "danger";
        case PPT_PENDING:
        case PPT_READYTOPROCESS:
          return "info";
        case PPT_UNPROCESSED:
        case PPT_INPROCESS:
        case PPT_PROCESSING:
          return "warning";
        default:
          return "secondary";
      }
    },
    getSlidesStatusLabel(presentation) {
      const status = presentation && presentation.slidesStatus;
      if (!status) return "N/A";
      if (
        presentation.processSlides !== null &&
        presentation.processSlides !== undefined &&
        presentation.totalSlides
      ) {
        return `${status}`;
      }
      return status;
    },
    handleSort(sortField) {
      const currentSortField = this.paginationParams.sort.split(",")[0];
      if (currentSortField === sortField) {
        this.paginationParams.sortDesc = !this.paginationParams.sortDesc;
      } else {
        this.paginationParams.sortDesc = false;
      }
      const direction = this.paginationParams.sortDesc ? "desc" : "asc";
      this.paginationParams.sort = `${sortField},${direction}`;
      this.paginationParams.page = 0;
      this.getPresentations();
    },
    handleSizeChange(size) {
      if (!size) return;
      this.paginationParams.size = size > 1000 ? 1000 : size;
      this.paginationParams.page = 0;
      this.getPresentations();
    },
    handlePageChange(page) {
      this.paginationParams.page = page - 1;
      this.getPresentations();
    },
    handleSearch() {
      this.paginationParams.page = 0;
      this.getPresentations();
    },
    clearFilters(event) {
      if (event) event.preventDefault();
      this.searchText = "";
      this.paginationParams.page = 0;
      this.getPresentations();
    },
    openCreateModal() {
      if (!this.currentFolder) return;
      this.resetForm();
      this.showFormModal = true;
    },
    openEditModal(presentation) {
      this.form = {
        id: presentation.id,
        name: presentation.name || presentation.title || "",
        description: presentation.description || "",
      };
      this.showFormModal = true;
      this.getPresentationSlides(presentation.id);
    },
    async openPresentationNotification(pptFile) {
      if (!pptFile || !pptFile.presentationId) {
        this.$toastr("success", "PPT slide processing is complete");
        return;
      }
      try {
        const response = await this.$api.getPresentationById(
          pptFile.presentationId,
        );
        const presentation =
          response && response.data && response.data.payload
            ? response.data.payload
            : null;
        if (presentation) {
          this.openEditModal(presentation);
        } else {
          this.$toastr("success", "PPT slide processing is complete");
        }
      } catch (error) {
        this.$handleError(error);
      }
    },
    async savePresentation() {
      const valid = await this.validatePresentationForm();
      if (!valid) {
        this.$toastr("error", this.$t("notes.fillAllValidDetails"));
        return;
      }
      if (!this.currentFolder || !this.form.name) return;
      if (this.pptFileError) return;
      const payload = {
        id: this.form.id,
        name: this.form.name,
        description: this.form.description,
        presentationFolder: {
          id: this.currentFolder.id,
        },
      };

      this.saving = true;
      try {
        let response = null;
        const hadPptFile = !!this.pptFile;
        if (payload.id) {
          response = await this.$api.updatePresentation(payload);
        } else {
          response = await this.$api.addPresentation(payload);
        }
        const savedPresentation =
          response && response.data && response.data.payload
            ? response.data.payload
            : payload;
        this.form.id = savedPresentation.id;
        if (hadPptFile) {
          await this.uploadPresentationPpt(savedPresentation);
        }
        this.$toastr("success", "Presentation saved successfully");
        if (!hadPptFile) {
          this.showFormModal = false;
        }
        this.getPresentations();
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.saving = false;
      }
    },
    handlePptFileSelected(file) {
      this.pptFile = file;
      if (file) {
        this.pptFileError = "";
      }
    },
    async validatePresentationForm() {
      const detailsValid = this.$refs.presentationDetailsSection
        ? await this.$refs.presentationDetailsSection.$validator.validateAll()
        : true;
      const pptValid = this.$refs.presentationPptUploadSection
        ? await this.$refs.presentationPptUploadSection.$validator.validateAll()
        : true;

      return detailsValid && pptValid;
    },
    handlePptFileInvalid(error) {
      this.pptFileError = error;
    },
    async uploadPresentationPpt(presentation) {
      const extension = this.getFileExtension(this.pptFile.name);
      if (!["ppt", "pptx"].includes(extension)) {
        throw new Error("Only PPT and PPTX files are allowed");
      }

      this.pptUploading = true;
      this.pptUploadStatus = "Uploading PPT";
      this.pptUploadProgress = 0;
      try {
        const uploadResponse = await this.$uploadLogoFact({
          file: this.pptFile,
          originalFileName: this.pptFile.name,
          onFileProgress: (id, progress) =>
            this.onPptFileProgress(id, progress),
        });
        const uploadPayload =
          uploadResponse && uploadResponse.data && uploadResponse.data.payload;
        if (!uploadPayload || !uploadPayload.uri || !uploadPayload.blobName) {
          throw new Error("Unable to upload PPT to storage");
        }
        console.log("PPT uploaded to storage:", uploadPayload);
        const pptFilePayload = {
          id: 0,
          fileSize: this.pptFile.size,
          fileType: extension,
          name: this.pptFile.name,
          pptsection: {
            name: "powerpoint",
          },
          status: "PENDING",
          path: uploadPayload.uri,
          rawFileName: uploadPayload.blobName,
          resourceId: uploadPayload.resourceId,
          containerName: uploadPayload.containerName,
        };

        this.pptUploadStatus = "Saving PPT metadata";
        this.pptUploadProgress = 100;
        const savePptResponse = await this.$api.savePresentationPptFile(
          pptFilePayload,
        );
        this.validatePresentationResponse(
          savePptResponse,
          "Unable to save PPT metadata",
        );
        const savedPptFile =
          savePptResponse &&
          savePptResponse.data &&
          savePptResponse.data.payload;
        const pptFileId =
          savedPptFile && savedPptFile.id ? savedPptFile.id : null;

        this.pptUploadStatus = "Processing slides";
        const convertResponse = await this.$api.convertPresentationPptSlides(
          uploadPayload.uri,
          presentation.id,
          pptFileId,
        );
        this.validatePresentationResponse(
          convertResponse,
          "Unable to process PPT slides",
        );

        this.pptUploadStatus = "Slides are processing";
        this.pptFile = null;
        this.$toastr(
          "info",
          "PPT slides are being processed. You will be notified when the processing is complete.",
        );
        this.$bvModal.hide("presentation-form-modal");
        await this.getPresentationSlides(presentation.id);
      } finally {
        this.pptUploading = false;
      }
    },
    onPptFileProgress(id, progress) {
      if (!progress || progress.fileStatus == null) return;
      const fileProgress = parseFloat(progress.fileStatus);
      this.pptUploadProgress = Number.isNaN(fileProgress)
        ? 0
        : Math.min(Math.max(fileProgress, 0), 100);
      this.pptUploadStatus = `Uploading PPT ${this.pptUploadProgress}%`;
    },
    validatePresentationResponse(response, fallbackMessage) {
      const data = response && response.data ? response.data : null;
      if (data && data.status === false) {
        throw new Error(data.statusMessage || fallbackMessage);
      }
      return true;
    },
    deletePresentationFact(presentation) {
      this.$deleteConfirmation(
        "Are you sure you want to delete this presentation?",
        () => {
          this.loading = true;
          this.$api.deletePresentation(presentation.id).then(
            (response) => {
              if (response.data.status) {
                this.$toastr("success", "Presentation deleted successfully");
                this.getPresentations();
              }
            },
            (error) => {
              this.$handleError(error);
              this.loading = false;
            },
          );
        },
      );
    },
    async openDocuments(presentation) {
      this.selectedPresentation = presentation;
      this.showDocumentsModal = true;
      await this.getDocuments();
    },
    async getPresentationSlides(presentationId) {
      if (!presentationId) {
        this.presentationSlides = [];
        return;
      }
      this.slidesLoading = true;
      try {
        const response = await this.$api.getPresentationSlides(presentationId, {
          size: 200,
          sort: "order,asc",
        });
        const payload = response && response.data && response.data.payload;
        this.presentationSlides =
          payload && payload.content ? payload.content : payload || [];
      } catch (error) {
        this.$handleError(error);
        this.presentationSlides = [];
      } finally {
        this.slidesLoading = false;
      }
    },
    async reorderPresentationSlides(orderedSlides) {
      if (!this.form.id || !orderedSlides || !orderedSlides.length) return;

      const previousSlides = this.presentationSlides.slice();
      const normalizedSlides = orderedSlides.map((slide, index) => ({
        ...slide,
        order: index + 1,
      }));
      this.presentationSlides = normalizedSlides;

      const payload = normalizedSlides.map((slide) => ({
        slideId: slide.id,
        order: slide.order,
      }));

      this.slidesSaving = true;
      try {
        const response = await this.$api.updatePresentationSlideOrder(
          this.form.id,
          payload,
        );
        this.validatePresentationResponse(
          response,
          "Unable to update slide order",
        );
        const responsePayload =
          response && response.data && response.data.payload;
        this.presentationSlides =
          responsePayload && responsePayload.content
            ? responsePayload.content
            : responsePayload || normalizedSlides;
      } catch (error) {
        this.presentationSlides = previousSlides;
        this.$handleError(error);
      } finally {
        this.slidesSaving = false;
      }
    },
    deletePresentationSlideFact(slide) {
      if (!this.form.id || !slide || !slide.id) return;

      this.$deleteConfirmation(
        "Are you sure you want to delete this slide?",
        () => {
          this.deletePresentationSlide(slide);
        },
      );
    },
    async deletePresentationSlide(slide) {
      const previousSlides = this.presentationSlides.slice();
      this.presentationSlides = this.presentationSlides.filter(
        (presentationSlide) => presentationSlide.id !== slide.id,
      );
      this.slidesSaving = true;
      try {
        const response = await this.$api.deletePresentationSlide(
          this.form.id,
          slide.id,
        );
        this.validatePresentationResponse(
          response,
          "Unable to delete presentation slide",
        );
        const responsePayload =
          response && response.data && response.data.payload;
        this.presentationSlides =
          responsePayload && responsePayload.content
            ? responsePayload.content
            : responsePayload || this.presentationSlides;
        this.$toastr("success", "Slide deleted successfully");
      } catch (error) {
        this.presentationSlides = previousSlides;
        this.$handleError(error);
      } finally {
        this.slidesSaving = false;
      }
    },
    async getDocuments() {
      if (!this.selectedPresentation) return;
      this.documentsLoading = true;
      try {
        const response = await this.$api.getPresentationDocuments(
          this.selectedPresentation.id,
        );
        const payload = response && response.data && response.data.payload;
        this.documents =
          payload && payload.content ? payload.content : payload || [];
      } catch (error) {
        this.$handleError(error);
        this.documents = [];
      } finally {
        this.documentsLoading = false;
      }
    },
    async uploadDocument() {
      if (!this.selectedPresentation || !this.documentFile) return;
      const formData = new FormData();
      formData.append("file", this.documentFile);

      this.uploading = true;
      try {
        await this.$api.uploadPresentationDocument(
          this.selectedPresentation.id,
          formData,
        );
        this.$toastr("success", "Document uploaded successfully");
        this.documentFile = null;
        this.getDocuments();
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.uploading = false;
      }
    },
    async deleteDocument(document) {
      const confirmed = await this.confirmAction("Delete this document?");
      if (!confirmed) return;

      this.documentsLoading = true;
      try {
        await this.$api.deletePresentationDocument(document.id);
        this.$toastr("success", "Document deleted successfully");
        this.getDocuments();
      } catch (error) {
        this.$handleError(error);
        this.documentsLoading = false;
      }
    },
    confirmAction(message) {
      if (this.$bvModal && this.$bvModal.msgBoxConfirm) {
        return this.$bvModal.msgBoxConfirm(message, {
          title: "Confirm",
          okVariant: "danger",
          okTitle: "Delete",
          cancelTitle: "Cancel",
          centered: true,
        });
      }
      return Promise.resolve(window.confirm(message));
    },
    resetForm() {
      this.form = {
        id: null,
        name: "",
        description: "",
      };
      this.pptFile = null;
      this.pptFileError = "";
      this.pptUploadStatus = "";
      this.pptUploadProgress = 0;
      this.presentationSlides = [];
      this.$nextTick(() => {
        if (this.$refs.presentationDetailsSection) {
          this.$refs.presentationDetailsSection.$validator.reset();
        }
        if (this.$refs.presentationPptUploadSection) {
          this.$refs.presentationPptUploadSection.$validator.reset();
        }
      });
    },
    resetDocuments() {
      this.selectedPresentation = null;
      this.documentFile = null;
      this.documents = [];
    },
    formatDate(date) {
      return date ? new Date(date).toLocaleDateString() : "N/A";
    },
    formatSize(size) {
      if (!size) return "N/A";
      if (size < 1024) return `${size} B`;
      if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
      return `${(size / (1024 * 1024)).toFixed(1)} MB`;
    },
    getFileExtension(name) {
      if (!name || !name.includes(".")) return "";
      return name.split(".").pop().toLowerCase();
    },
  },
};
</script>
<style scoped>
  .fs-13 {
    font-size: 13px !important;
  }
</style>
